export default __webpack_public_path__ + "static/media/hipaa_badge.b4473f52.svg";